import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Campeonatos() {
  const [campeonatos, setCampeonatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/campeonatos').then(setCampeonatos).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div>
      <h1 className="page-title">Campeonatos</h1>
      {campeonatos.length === 0 && <p style={{ color: 'var(--text2)', textAlign: 'center', padding: 40 }}>Nenhum campeonato disponível.</p>}
      {campeonatos.map(c => (
        <div key={c.id} className="card" style={{ marginBottom: 14, cursor: 'pointer' }}
          onClick={() => navigate('/jogos', { state: { campeonato_id: c.id } })}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <strong style={{ fontSize: 16, display: 'block', marginBottom: 4 }}>{c.nome}</strong>
              <span style={{ fontSize: 12, color: 'var(--text2)' }}>{c.cidade_nome} • {c.temporada_nome} {c.temporada_ano}</span>
            </div>
            <span className={`badge ${c.ativo ? 'badge-success' : 'badge-danger'}`}>{c.ativo ? 'Ativo' : 'Encerrado'}</span>
          </div>
          {c.descricao && <p style={{ fontSize: 13, color: 'var(--text2)', marginTop: 10 }}>{c.descricao}</p>}
        </div>
      ))}
    </div>
  );
}
